import * as React from "react"
const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={10} fill="none">
    <path
      fill="#1F1F1F"
      d="M.666 4.992c4.346-6.334 14.94-6.326 19.185.014-4.346 6.335-14.94 6.327-19.185-.014Zm9.583-3.623c-1.912.006-3.588 1.666-3.62 3.585-.033 1.94 1.691 3.683 3.639 3.676 1.912-.007 3.588-1.667 3.62-3.585.033-1.942-1.692-3.683-3.64-3.676Z"
    />
    <path
      fill="#1F1F1F"
      d="M10.209 3.104c1.067-.022 1.91.766 1.944 1.819.036 1.115-.794 1.978-1.9 1.975A1.866 1.866 0 0 1 8.36 5.022c-.01-1.065.79-1.896 1.846-1.918h.002Z"
    />
  </svg>
)
export default EyeIcon
